@let serviceOffering = this.serviceOffering();

<div class="OfferingCard__inner">
  @if (!showMenu()) {
    <header class="OfferingCard__header">
      @switch (imageHref()) {
        @case ('shape-country-risk') {
          <grid-ui-icon id="country-risk-icon" class="OfferingCard__icon" name="country-risk" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-video') {
          <grid-ui-icon id="learn-icon" class="OfferingCard__icon" name="video" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-sovereign-esg-ratings') {
          <grid-ui-icon id="sovereign-esg-ratings-icon" class="OfferingCard__icon" name="sovereign" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-commodity-risk') {
          <grid-ui-icon id="commodity-risk-icon" class="OfferingCard__icon" name="commodity-risk" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-industry-risk') {
          <grid-ui-icon id="industry-risk-icon" class="OfferingCard__icon" name="industry-chart" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-corporate-exposure') {
          <grid-ui-icon id="corporate-exposure-icon" class="OfferingCard__icon" name="corporate-exposure" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-data-wizard') {
          <grid-ui-icon id="data-wizard-icon" class="OfferingCard__icon" name="data-wizard" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-document-library') {
          <grid-ui-icon id="document-library-icon" class="OfferingCard__icon" name="document-library" data-hook="icon"></grid-ui-icon>
        }
        @case ('shape-news-and-events') {
          <grid-ui-icon id="webinars-icon" class="OfferingCard__icon" name="calendar" data-hook="icon"></grid-ui-icon>
        }
        @default {
          @if (imageHrefIsSvg()) {
            <div class="OfferingCard__icon" [innerHTML]="getExtSvg(imageHref()) | async" data-hook="icon"></div>
          }
        }
      }
    </header>
  }

  <div class="OfferingCard__details">
    <h2 class="OfferingCard__title" data-hook="title">{{ serviceOffering.label }}</h2>

    @if (!showMenu()) {
      <p class="OfferingCard__description" data-hook="description">{{ serviceOffering.description }}</p>
    }
  </div>

  @if (showMenu()) {
    <nav data-hook="quick-jump-menu">
      <ul class="OfferingCard__quick-links">
        @for (item of serviceOffering.menu; track item.link) {
          <li>
            <a
              class="OfferingCard__quick-link"
              (click)="linkClick(item.link)"
              data-hook="quick-jump-link"
              [attr.data-testid]="'link-' + item.label | slugify"
            >
              <span class="OfferingCard__quick-link-text">
                {{ item.label }}

                @if (item.badge) {
                  <grid-ui-badge
                    *mcPermission="item.badge.permissionSelector"
                    class="OfferingCard__badge"
                    [text]="item.badge.text"
                  ></grid-ui-badge>
                }
              </span>
            </a>
          </li>
        }
      </ul>
    </nav>
  }

  @if (serviceOffering.menu?.length > 1) {
    <footer class="OfferingCard__footer">
      <button
        class="OfferingCard__button btn mc-btn-secondary"
        (click)="toggleMenu($event)"
        data-hook="quick-jump-button"
        data-testid="btn-quick-jump"
      >
        Quick Jump

        <grid-ui-icon
          class="OfferingCard__chevron"
          [class.OfferingCard__chevron--open]="showMenu()"
          name="chevron-circle-up"
        ></grid-ui-icon>
      </button>
    </footer>
  }
</div>
